export { BloomFilter } from './bloom-filter';
export { CountingBloomFilter } from './counting-bloom-filter';
export function optimal(items, errorRate) {
    const size = Math.ceil(-(items * Math.log(errorRate)) / Math.LN2 ** 2);
    const hashes = Math.round((size / items) * Math.LN2);
    return { size, hashes };
}
//# sourceMappingURL=index.js.map